<template>
    <div :style="{'height' : domHeight +'px' }">
        <div name="query-sort-block" class="mt10 mb10" style="padding-right:50px;">
            <swb-query-sort-area ref="query_sort_area" :config="queryConfig" :resultColConf="resultColConf" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
            <img v-if="metaColList != null && metaColList.length > 0 && !hasTabFlag" v-resc-url="'/image/excel-ex.png'" style="position:absolute;top:71px;right:10px;border-radius:4px;" height="36" width="36" @click="exportExcel" title="导出Excel"/>
            <img v-if="metaColList != null && metaColList.length > 0 && hasTabFlag" v-resc-url="'/image/excel-ex.png'" style="position:absolute;top:148px;right:10px;border-radius:4px;" height="36" width="36" @click="exportExcel" title="导出Excel"/>
        </div>
        <div name="toolbar" class="left-toolbar fl" v-if="comInfo.id != null">
            <div class="inline-block ml15">当前公司：<span>{{comInfo.name || '无'}}</span></div>
        </div>
        <!--<div class="inline-block mr15 fr" v-if="reportInfo.total != null">总条数：<span>{{reportInfo.total || 0}}</span></div>-->
        <!--<div v-html='reportInfo.htmlTable'></div>-->
        <swb-result-table name="result_table" v-show="metaColList != null && metaColList.length > 0" ref="result_table" :metaColList="metaColList" :needPager="true" :rowNoShow="false" :height="tableHeight" :minColWidth="minColWidth" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, H5file, Jqext, Store, EventBus, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { showGrpDownloadDlg } from '../ctrl/dialog'

    import SwbResultTable from '../query/ResultTable'

    Vue.regist(SwbResultTable);

    // 下載excel
    let FileDownloader = H5file.Downloader;
    let $id = window.$id || Jqext.$id;
    //报表专用事件总线
    const reportEventBus = EventBus.get("report-events");
    const repeatChecker = Utils.repeatChecker;
    //全局报表单元格链接函数
    window.showReportDetail = function (dataMap, reportCode, colName) {
        if(repeatChecker.isValidFor("showReportDetail", 500)) {
            //防止快速连续点击
            //
            reportEventBus.trigger("cell-click", {
                dataMap: dataMap,
                reportCode: reportCode,
                colName: colName
            });
        }
    };

    import userApi from '../../api/user'
    import easyReportApi from '../../api/easyReport'

    export default {
        name: 'swb-easy-report-table-test',
        desc: '报表',
        /*
         reportName: 报表名称
         reportCode: 报表自定义代码
         paramMap: 报表隐藏参数默认值 ps: {retailerId: 259, shopId: 71}
         hideParamKeys：报表隐藏参数 数组：ps: ["retailerId", "shopId"]
         */
        // props: ['reportName', 'reportCode', 'paramMap', 'hideParamKeys', 'comInfo'],
        props: {
            reportName: {
                type: String,
                default: null
            },
            reportCode: {
                type: String,
                default: null
            },
            paramMap: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            paramKeys: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            hideParamKeys: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            comInfo: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            includeSubComs: {
                type: Boolean,
                default: false
            },
            detailComponentUrl: { // 需要跳转的详情的url
                type: String,
                default: null
            },
            showStatColumns: {
                type: Boolean,
                default: true
            },
            queryData: {
                type: Boolean,
                default: false
            },
            hasTabFlag: {
                type: Boolean,
                default: false
            },
            showResultColConf: {
                type: Boolean,
                default: true
            },
            domHeight: {
                default: 'auto'
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                total: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                reportInfo: {},
                htmlFilter: null,
                htmlTable: null,
                //
                queryConfig: {},
                queryKey: null,
                queryModel: {
                    filterItems: {},
                },
                // 统计列
                statColumns: [],
                statColumnNames: [],
                //
                currentParams: {},
                currentDate: new Date(),
                //
                cacheKey: null,
                //
                metaColList: [],
                tableHeight: 'auto', //表格高度
                minColWidth: 120,
                resultColConf: null,

                exportParams: {}
            }
        },
        watch: {
            reportCode(newVal, oldVal) {
                if(newVal != oldVal) {
                    //
                    this.reportInfo = {};
                    this.htmlFilter = null;
                    this.htmlTable = null;
                    this.queryConfig = {};
                    this.queryKey = null;
                    this.queryModel = {
                        filterItems: {},
                        sortItemList: []
                    };
                    this.statColumns = [];
                    this.statColumnNames = [];
                    this.cacheKey = null;
                    this.metaColList = [];
                    this.resultColConf = null;
                    this.exportParams = {};
                    this.renderTable([], 0);
                    //
                    this.getCurrentUserInfo();
                }
            },
            comInfo(newVal, oldVal) {
                if(newVal != oldVal) {
                    //
                    this.getEasyReportTableHtml();
                }
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], [name="toolbar"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //注册事件监听函数
            reportEventBus.bind(
                "cell-click",
                this.handleReportCellClick,
                this,
                "这是" + Vue.$getClassInfo(this).name
            );
            //
            this.currentParams = Utils.merge({}, this.paramMap);
            this.getCurrentUserInfo();
            //
            // TODO 删除 - 仅留 getCurrentUserInfo
            // this.fetchReportInitParams();
        },
        beforeDestroy() {
            //注销事件监听函数
            reportEventBus.unbind("cell-click", this.handleReportCellClick);
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let query_sort_area = this.$refs['query_sort_area'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_sort_area);
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //
                this.getEasyReportTableHtml();
            },
            getCurrentUserInfo: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        //
                        let currentParams = self.currentParams;
                        currentParams.retailerId = scopeEntity.id;
                        currentParams.cxtMerchantId = scopeEntity.id;
                        currentParams.cxtMerchantIdX = scopeEntity.id;
                        self.currentParams = Utils.merge({}, currentParams);
                        self.cacheKey = self.reportCode + '_' + scopeEntity.id;
                        //
                        self.fetchReportInitParams();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取初始参数
            fetchReportInitParams: function () {
                let self = this;
                let postData = {
                    reportCode: this.reportCode,
                    paramMap: this.currentParams
                };
                let theLoad = MsgBox.loading();
                easyReportApi.fetchReportInitParamsX(postData, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        //
                        let resultData = result.data;
                        //
                        let initExtra = resultData.initExtra;
                        let statColumns = initExtra.statColumns || [];
                        // 初始参数
                        let initParams = resultData.initParams;
                        let queryData = Utils.merge({}, self.makeParams(initParams, statColumns));
                        let filterItems = queryData.filterItems;
                        let searchConfigData = queryData.searchConfigData || null;
                        if(Utils.isNoB(searchConfigData)) {
                            searchConfigData = {};
                            searchConfigData.queryFields = [];
                        }
                        let queryFields = searchConfigData.queryFields;
                        // 合并左边相同维度行
                        let isRowSpan = resultData.isRowSpan;
                        let newField = self.getQueryFieldItem("Checkbox", "Boolean", "合并左边相同维度行", 'isRowSpan', isRowSpan, true);
                        queryFields.push(newField);
                        // filterItems["isRowSpan"] = isRowSpan;
                        // 统计列
                        if(Utils.isTrue(self.showStatColumns)) {
                            let statColumnsCache = Store.get(self.cacheKey) || [];
                            for(let i = 0; i < statColumns.length; i++) {
                                let statColumn = statColumns[i];
                                let statNameX = 'stat-' + statColumn.name;
                                let selected = statColumn.selected;
                                if(statColumnsCache.length > 0 && !statColumnsCache.contains(statNameX)) {
                                    selected = false;
                                }
                                newField = self.getQueryFieldItem("Checkbox", "Boolean", statColumn.text, statNameX, selected, false);
                                queryFields.push(newField);
                                // filterItems[statColumn.name] = statColumn.selected;
                                self.statColumnNames.push(statColumn.name);
                            }
                            self.statColumns = statColumns;
                        }
                        //
                        self.queryConfig = searchConfigData;
                        // 获取列数据
                        self.getMetaColList();
                        // 添加隐藏参数
                        self.addHideParams(filterItems);
                        self.queryModel.filterItems = Utils.merge({}, filterItems);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 添加隐藏参数
            addHideParams: function (filterItems) {
                let hideParamKeys = this.hideParamKeys || [];
                let currentParams = this.currentParams;
                for(let i = 0; i < hideParamKeys.length; i++) {
                    let param = hideParamKeys[i];
                    filterItems[param] = currentParams[param];
                }
            },
            // 获取列数据信息
            getMetaColList: function () {
                let self = this;
                let postData = {
                    reportCode: self.reportCode
                };
                easyReportApi.getReportMetaColList(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        //
                        let metaColList = result.data || [];
                        // 设置列宽
                        self.resetMeatColWidth(metaColList);
                        if(Utils.isTrue(self.showResultColConf)) {
                            let resultColConf = {
                                metaColList: metaColList
                            };
                            self.resultColConf = Utils.merge({}, resultColConf);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 设置列宽
            resetMeatColWidth: function (metaColList) {
                for(let i = 0; i < metaColList.length; i++) {
                    let metaCol = metaColList[i];
                    if(i = metaColList.length - 1) {
                        metaCol.width = 'auto';
                    }
                }
                this.metaColList = Utils.merge([], metaColList);
            },
            // 分页切换
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);

                let resultTable = this.$refs.result_table;
                console.log(resultTable.getPagination());

                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getEasyReportTableHtml();
            },
            getEasyReportTableHtml: function () {
                let self = this;
                let sortItemList = Utils.merge([], self.queryModel.sortItemList);
                let filterItems = self.makePostDataParams();
                filterItems.comId = self.comInfo.id;
                filterItems.comLevel = self.comInfo.level;
                filterItems.includeSubComs = self.includeSubComs;
                filterItems.show_dataLinks = self.paramMap.show_dataLinks || false;
                filterItems.page_no = self.pageNumber;
                filterItems.page_size = self.pageSize;
                filterItems.sort_items = sortItemList;
                let postData = {
                    reportCode: this.reportCode,
                    paramMap: filterItems
                };
                self.exportParams = postData;
                let theLoading = MsgBox.loading();
                easyReportApi.getReportResultDatas(postData, function (result, jqXhr) {
                    theLoading.hide();
                    if(result.type == 'info') {
                        //取消双击行背景着色
                        $(".easyreport tbody > tr").unbind('dblclick');
                        //
                        let reportInfo = result.data;
                        self.reportInfo = Utils.merge({}, reportInfo);
                        self.renderTable(reportInfo.rows, reportInfo.total);
                        //
                        self.total = reportInfo.total;
                        //设置双击行背景着色
                        setTimeout(
                            function () {
                                $(".easyreport tbody > tr").bind('dblclick', function () {
                                    $(this).toggleClass('selected');
                                });
                            }
                            , 1000);

                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 渲染数据
            renderTable(rows, total) {
                //let resultColConfCmp = this.$refs['result_col_conf'];
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                // let confColList = resultColConfCmp.getMetaColList();
                //resultTable.initMeta(confColList);
                let dataMap = {
                    pagination: {
                        totalCount: total,
                        pageNumber: this.pageNumber
                    },
                    rows: rows
                };
                //设置新数据
                resultTable.render(dataMap);
            },
            // 提交参数
            makePostDataParams: function () {
                //
                let filterItems = this.queryModel.filterItems;
                if(Utils.isTrue(this.showStatColumns)) {
                    let statColumnsCache = Store.get(this.cacheKey) || [];
                    if(statColumnsCache.length > 0) {
                        filterItems.statColumns = statColumnsCache;
                        for(let i = 0; i < statColumnsCache.length; i++) {
                            let columns = statColumnsCache[i];
                            if(!Utils.isNoB(filterItems[columns])) {
                                break;
                            }
                            filterItems[columns] = true;
                        }
                    }
                }
                this.addHideParams(filterItems);
                //
                if(Utils.isTrue(this.showStatColumns)) {
                    let cacheStatColumns = [];
                    let statColumnNames = this.statColumnNames || [];
                    let statColNames = statColumnNames.filter(function (colName) {
                        let colNameX = 'stat-' + colName;
                        let boolVal = Utils.isTrue(filterItems[colNameX]) !== false;
                        if(Utils.isTrue(boolVal)) {
                            cacheStatColumns.push(colNameX);
                        }
                        delete filterItems[colNameX];
                        return boolVal;
                    });
                    filterItems.statColumns = Utils.merge([], statColNames);
                    Store.set(this.cacheKey, cacheStatColumns);
                }
                return filterItems;
            },
            makeHtmlFilter: function (filterItems) {
                let reportTbl = $id("easyreport");
                if(reportTbl.length > 0) {
                    reportTbl = reportTbl.get(0);
                }
                else {
                    return null;
                }
                let headRow = reportTbl.tHead.rows[0];
                let headRowCells = headRow.cells;
                let colCount = 0;
                for(let i = 0, c = headRowCells.length; i < c; i++) {
                    let colSpan = headRowCells[i].colSpan || 1;
                    colCount += colSpan;
                }
                // 最大可视化列为12列
                colCount = Math.min(colCount, 12);
                //
                let queryConfig = this.queryConfig;
                let queryFields = queryConfig.queryFields || [];
                let htmlFilter = "<table>";
                //标题 + 导出时间
                htmlFilter += ("<tr><td align='center' colspan='{colSpan}'><h3>{reportName}</h3></td></tr>" +
                    "<tr><td align='right' colspan='{colSpan}'><h3>导出时间：{exportTime}</h3></td></tr>").format({
                    colSpan: colCount,
                    reportName: this.reportName,
                    exportTime: this.currentDate.format('yyyy-MM-dd HH:mm:ss')
                });
                let filterItemTpl = "<tr><td><strong>{label}</strong></td><td align='left' colspan='{colSpan}'>{value}</td></tr>";
                for(let i = 0; i < queryFields.length; i++) {
                    let queryField = queryFields[i];
                    // 选中的条件值
                    let selectValue = filterItems[queryField.code];
                    if(selectValue != null && queryField.code != 'isRowSpan') {
                        if(queryField.hidden) {
                            continue;
                        } else {
                            let label = queryField.label;
                            let textValue = null;
                            if(queryField.type == "Select") {
                                let dataList = queryField.dataList;
                                let dataValue = queryField.dataValue;
                                let dataLabel = queryField.dataLabel;
                                let vals = [];
                                if(queryField.multiple) {
                                    vals = selectValue || [];
                                } else {
                                    vals.add(selectValue);
                                }
                                let textList = [];
                                for(let k = 0; k < dataList.length; k++) {
                                    let result = dataList[k];
                                    let val = result[dataValue];
                                    if(vals.contains(val)) {
                                        textList.add(result[dataLabel]);
                                    }
                                }
                                textValue = textList.join("、");
                            } else if(queryField.type == "Checkbox") {
                                textValue = selectValue ? '是' : '否';
                            } else {
                                textValue = selectValue;
                            }
                            htmlFilter += filterItemTpl.format({label: label, colSpan: colCount - 1, value: textValue});
                        }
                    }
                }
                // 筛选统计列
                if(Utils.isTrue(this.showStatColumns)) {
                    let statColumns = this.statColumns;
                    let statTextList = [];
                    for(let i = 0; i < statColumns.length; i++) {
                        let statColumn = statColumns[i];
                        if(filterItems.statColumns.contains(statColumn.name)) {
                            statTextList.add(statColumn.text);
                        }
                    }
                    htmlFilter += filterItemTpl.format({label: "筛选统计列", colSpan: colCount - 1, value: statTextList.join("、")});
                }
                htmlFilter += "<tr></tr>";
                htmlFilter += "</table>";
                this.htmlFilter = htmlFilter;
                // console.log(htmlFilter);
            },
            //
            makeParams: function (queryFields, statColumns) {
                let paramKeys = this.paramKeys || [];
                // 跳转详情需要的参数
                let groupName = this.paramMap.groupName || null;
                let servcCatName = this.paramMap.servcCatName || null;
                //
                let searchConfigData = null;
                let filterItems = {};   // 默认参数
                if(!Utils.isNoB(queryFields) && queryFields.length > 0) {
                    let newQueryFields = [];
                    for(let i = 0; i < queryFields.length; i++) {
                        let queryField = queryFields[i];
                        //
                        let defValue = queryField.defValue;
                        if(paramKeys.contains(queryField.name)) {
                            defValue = this.paramMap[queryField.name];
                        }
                        filterItems[queryField.name] = defValue;
                        //
                        let newField = {};
                        let dataType = queryField.dataType;
                        if(dataType == 'date') {
                            //
                            newField = this.getQueryFieldItem("Date", "String", queryField.text, queryField.name, defValue, true);
                        } else if(dataType == 'integer' || dataType == 'string') {
                            //
                            let valueType = dataType == 'integer' ? 'Integer' : 'String';
                            //
                            let dataList = queryField.options || [];
                            let noneVal = dataList.length == 0 ? true : false;
                            switch(queryField.ctrlType) {
                                case "select":
                                    defValue = noneVal ? null : defValue == null ? dataList[0].value : defValue;
                                    defValue = defValue == null ? '' : defValue;
                                    newField = this.getQueryFieldItem("Select", valueType, queryField.text, queryField.name, defValue + '',//
                                        true, false, queryField.options, "text", "value");
                                    break;
                                case "selectMul":
                                    defValue = noneVal ? [] : [dataList[0].name];
                                    if(queryField.name == 'groupIds' && !Utils.isNoB(groupName)) {
                                        for(let g = 0; g < dataList.length; g++) {
                                            let dataInfo = dataList[g];
                                            if(groupName == dataInfo.text) {
                                                defValue = [];
                                                defValue.push(dataInfo.name);
                                                break;
                                            }
                                        }
                                    } else if(queryField.name == 'catIds' && !Utils.isNoB(servcCatName)) {
                                        for(let g = 0; g < dataList.length; g++) {
                                            let dataInfo = dataList[g];
                                            if(servcCatName == dataInfo.text) {
                                                defValue = [];
                                                defValue.push(dataInfo.name);
                                                break;
                                            }
                                        }
                                    }
                                    newField = this.getQueryFieldItem("Select", valueType, queryField.text, queryField.name, defValue,//
                                        true, true, queryField.options, "text", "name");
                                    break;
                                default:
                                    if(!this.hideParamKeys.contains(queryField.name)) {
                                        newField = this.getQueryFieldItem("Text", valueType, queryField.text, queryField.name, defValue, true);
                                    }
                            }
                        } else if(dataType == 'bool' || dataType == 'boolean') {
                            newField = this.getQueryFieldItem("Checkbox", "Boolean", queryField.text, queryField.name, Utils.isTrue(defValue), true);
                        }
                        //
                        newQueryFields.push(newField);
                    }
                    searchConfigData = searchConfigData == null ? {} : searchConfigData;
                    searchConfigData.queryFields = newQueryFields;
                }
                if(!Utils.isNoB(statColumns) && statColumns.length > 0) {
                    let sortFields = this.makeSortFields(statColumns) || [];
                    searchConfigData = searchConfigData == null ? {} : searchConfigData;
                    searchConfigData.sortFields = sortFields;
                }
                let result = {
                    filterItems: filterItems,
                    searchConfigData: searchConfigData
                };
                return result;
            },
            // 条件查询项
            getQueryFieldItem: function (type, valueType, label, code, value, basic, multiple, dataList, dataLabel, dataValue) {
                let newField = {};
                newField.type = type;
                newField.valueType = valueType;
                newField.label = label;
                newField.code = code;
                newField.value = value;
                newField.basic = basic;
                //
                if(Utils.isTrue(multiple)) {
                    newField.multiple = multiple;
                }
                if(type == "Select") {
                    newField.dataLabel = dataLabel;
                    newField.dataValue = dataValue;
                    //
                    newField.dataList = dataList;
                }
                return newField;
            },
            // 排序项
            makeSortFields: function (statColumns) {
                let sortFields = [];
                if(!Utils.isNoB(statColumns) && statColumns.length > 0) {
                    for(let i = 0; i < statColumns.length; i++) {
                        let statColumn = statColumns[i];
                        let sortField = {
                            label: statColumn.text,
                            code: statColumn.name,
                            order: "desc",
                            enabled: true
                        };
                        sortFields.add(sortField);
                    }
                }
                return sortFields;
            },
            // 导出Excel
            exportExcel: function () {
//                let filterItems = this.queryModel.filterItems;
//                this.makeHtmlFilter(filterItems);
//                let htmlTable = this.htmlTable;
//                htmlTable = htmlTable.replace(/<table\s+/ig, '<table cellpadding="3" cellspacing="0"  border="1" rull="all" style="border-collapse:collapse" ');
//                let htmlContent = this.htmlFilter + htmlTable;
//                let fileName = this.reportName + '_' + this.currentDate.format('yyyyMMdd_HHmmss');
//                FileDownloader.downloadHtmlAsXls(htmlContent, fileName);
                //
                let self = this;
                let fileName = self.reportName + '_' + self.currentDate.format('yyyyMMdd_HHmmss');
                let postData = self.exportParams;
                postData.fileName = fileName;
                let theLoading = MsgBox.loading();
                easyReportApi.getReportResultExportParams(postData, function (result, jqXhr) {
                    theLoading.hide();
                    if(result.type == 'info') {
                        if(!Utils.isNoB(result) && !Utils.isNoB(result.data)) {
                            let url = getAppUrl('/api/report/result/export/do');
                            let pages = Math.ceil(self.total / 2000);
                            let downloadUrls = [];
                            for(let i = 0; i < pages; i++) {
                                let params = {
                                    url: url,
                                    params: {
                                        uuid: result.data,
                                        pages: pages,
                                        pageNumber: i + 1,
                                        pageSize: 2000,
                                    },
                                    fileName: fileName + (pages == 1 ? '' : ("_" + (i + 1))),
                                    seqNo: i + 1
                                };
                                downloadUrls.push(params);
                            }
                            showGrpDownloadDlg(self.reportName + ' - 批量下载', downloadUrls);
                        } else {
                            MsgBox.warning("导出失败");
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            // 单元格跳转时间回调
            handleReportCellClick(eventName, eventData) {
                console.log(eventData);
                //
                let {dataMap, reportCode, colName} = eventData;
                if(!Utils.isNoB(dataMap)) {
                    let colValue = dataMap[colName];
                    if(Utils.isNoB(colValue) || colValue <= 0) {
                        return;
                    }
                }
                // 具体逻辑
                let detailComponentUrl = this.detailComponentUrl;
                if(Utils.isNoB(detailComponentUrl)) {
                    MsgBox.warning("请确定要跳转的详情的url");
                    return;
                }
                //
                let filterItems = this.queryModel.filterItems || {};
                // 工程师工作量跳转使用
                let paramMap = this.paramMap;
                if(!Utils.isNoB(paramMap.chiefFlag)) {
                    filterItems.chiefFlag = paramMap.chiefFlag;
                }
                // 跳转详情参数
                if(!Utils.isNoB(dataMap)) {
                    // 零售商
                    filterItems.groupName = dataMap.专业分类 || dataMap.groupName || null;
                    filterItems.servicerName = dataMap.服务商 || dataMap.servicerName || '';
                    filterItems.retailerShopName = dataMap.retailerShopName || '';
                    // 服务商
                    filterItems.servicerShopName = dataMap.网点 || dataMap.shopName || '';
                    filterItems.engineerName = dataMap.工程师 || dataMap.engineerName || '';
                    filterItems.phoneNo = dataMap.手机号 || '';
                    filterItems.retailerName = dataMap.retailerName || '';
                    filterItems.servcCatName = dataMap.servcCatName || '';
                    filterItems.servcName = dataMap.servcName || '';
                }
                // 跳转详情
                this.$router.push({
                    query: {dataJson: filterItems, colName: colName},
                    path: detailComponentUrl
                });

            }
        }
    }
</script>

<style>
    .easyreport {
        width: 100%;
    }

    .easyreport .easyreport-header th, .easyreport .easyreport-header td {
        height: 24px;
        background-color: #308ca5;
        border-right: 1px solid #ccc;
        border-top: none;
        text-align: center;
        color: #fff;
    }

    /*.easyreport tr.easyreport-row {*/
    /*background-color: rgba(230, 241, 245, 0.68);*/
    /*}*/

    .easyreport tr:hover td {
        background-color: rgba(254, 245, 194, 0.8) !important;
    }

    /*.easyreport tr.easyreport-row:hover {*/
    /*background-color: rgba(254, 237, 141, 0.8);*/
    /*}*/

    /*.easyreport tr.selected, .easyreport tr.easyreport-row.selected {*/
    /*background-color: rgba(228, 38, 185, 0.18);*/
    /*}*/

    .easyreport th, .easyreport td {
        padding: 8px 10px;
        border-right: 1px solid #ccc;
        color: black;
    }

    .easyreport .easyreport-fixed-column {
        background-color: rgba(236, 251, 210, 0.65);
        font-weight: bold;
        font-size: 11px;
        text-align: left;
    }

    .easyreport th {
        background-color: #308ca5;
        border: 1px solid #ccc;
        font-size: 11px;
        color: #fff;
        text-align: center;
        padding: 8px 2px 8px 2px;
    }

    .easyreport td a {
        text-decoration: underline;
        color: black;
    }

    .easyreport td {
        border: 1px solid #ccc;
        text-align: center;
        font-size: 11px;
        height: 18px;
    }

    .designer-table td {
        border: solid 0.1px #e6e6e6
    }

    .designer-table .j-item {
        float: left;
        margin-right: 4px;
        line-height: 25px;
    }

</style>



// WEBPACK FOOTER //
// src/compo/easyReport/EasyReportTest.vue